// extracted by mini-css-extract-plugin
export default {"all":"default_all__dLQsB","allSpaced":"default_allSpaced__N3iPH","surfaceSpaced":"default_surfaceSpaced__6KfN3"};